// src/environments/environment.staging.ts
export const environment = {
  production: false,
  apiUrl: 'https://api.uat.hexacorp.xyz',
  envName: 'staging', // added environment name
};
